<script setup lang="ts">
import type { TimePickerFieldProps } from '@/components/pickerFields/TimePickerField.vue';

import DatePickerField from '@/components/pickerFields/DatePickerField.vue';
import TimePickerField from '@/components/pickerFields/TimePickerField.vue';
// import { requiredValidationRule } from '@/helpers/validationRules';

export interface Model {
  date?: Date | string | null;
  time?: TimePickerFieldProps['modelValue'];
}

export interface Props {
  disabled?: boolean;
  loading?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  disabled: false,
  loading: false,
});

const model = defineModel<Model>({
  default: () => ({}),
});
</script>

<template>
  <fieldset :class="$style.dateTimeFieldset" data-testid="dateTimeFieldset">
    <legend :class="$style.legend">
      <slot name="legend">Departed</slot>
    </legend>
    <div :class="$style.container">
      <div :class="$style.item">
        <DatePickerField
          v-model="model.date"
          size="md"
          label="Date"
          :class="$style.field"
          :disabled="props.disabled"
          :loading="props.loading"
        />
      </div>
      <div :class="$style.item">
        <TimePickerField
          v-model="model.time"
          size="md"
          label="Time"
          :class="$style.field"
          :disabled="props.disabled"
          :loading="props.loading"
        />
      </div>
    </div>
  </fieldset>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.dateTimeFieldset {
  border: 0;
  margin: 0;
  padding: 0;
}
  .legend {
    font-size: 1rem;
    font-weight: 500;
    float: left;
    margin: 0 0 5px 0;

    & + * {
      clear: left;
    }
  }
  .container {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }
    .item {
      width: calc(50% - 1rem/2);
    }
      .field {
        margin-top: 0.5rem;
      }
</style>
